import { benefitsData } from '@/mocks/homeData';

const benefitImages: Record<string, string> = {
  'benefit-qc-v2': 'https://readdy.ai/api/search-image?query=Professional%20quality%20control%20photography%20setup%20with%20fashion%20garment%20inspection%20using%20careful%20hands%20on%20minimal%20warm%20beige%20desk%20soft%20natural%20lighting%20clean%20editorial%20style%20detailed%20fabric%20examination%20aesthetic%20workspace%20warm%20neutral%20tones&width=800&height=1000&seq=benefit-qc-v2&orientation=portrait',
  'benefit-compare-v2': 'https://readdy.ai/api/search-image?query=Elegant%20side%20by%20side%20comparison%20of%20two%20similar%20but%20distinct%20fashion%20items%20on%20warm%20beige%20surface%20minimal%20aesthetic%20soft%20natural%20daylight%20clean%20editorial%20photography%20subtle%20differences%20highlighted%20professional%20catalog%20style%20with%20gentle%20shadows&width=800&height=1000&seq=benefit-compare-v2&orientation=portrait',
  'benefit-speed-v2': 'https://readdy.ai/api/search-image?query=Modern%20minimal%20workspace%20with%20sleek%20laptop%20displaying%20fast%20loading%20product%20grid%20interface%20on%20warm%20beige%20desk%20soft%20natural%20lighting%20editorial%20style%20efficient%20organized%20layout%20aesthetic%20technology%20photography%20warm%20neutral%20background&width=800&height=1000&seq=benefit-speed-v2&orientation=portrait',
};

export default function BenefitsSection() {
  return (
    <section id="vorteile" className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            Warum OOPBuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Immer mehr Deutsche vertrauen auf das OOPBuy Spreadsheet für ihren Einkauf – aus guten Gründen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {benefitsData.map((benefit) => {
            const imgSrc = benefitImages[benefit.imageSeq] || benefitImages['benefit-qc-v2'];
            return (
              <div
                key={benefit.title}
                className="group rounded-2xl overflow-hidden border border-background-200/60 hover:border-background-300 transition-all duration-300 bg-background-50"
              >
                <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
                  <img
                    src={imgSrc}
                    alt={`OOPBuy Spreadsheet ${benefit.title}`}
                    title={`OOPBuy Spreadsheet ${benefit.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-foreground-950/10 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                    <h3 className="text-lg md:text-xl font-heading font-bold text-white mb-1">{benefit.title}</h3>
                    <p className="text-white/80 text-xs md:text-sm leading-relaxed">{benefit.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}